/**
 * Reusable inline attribution — every "Powered by Social Pulse ®" appearance
 * hyperlinks to socialpulse.com in a new tab.
 */
export function PoweredBySocialPulse({ className = "" }) {
  return (
    <a
      href="https://socialpulse.com"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="powered-by-social-pulse"
      className={`inline-flex items-center gap-1 hover:text-[color:var(--rust)] transition-colors ${className}`}
    >
      Powered by Social Pulse ®
    </a>
  );
}

/**
 * Inline "SocialPulse" link used inside body prose. Preserves parent typography.
 */
export function SocialPulseLink({ children = "SocialPulse", className = "" }) {
  return (
    <a
      href="https://socialpulse.com"
      target="_blank"
      rel="noopener noreferrer"
      data-testid="social-pulse-link"
      className={`link-underline hover:text-[color:var(--rust)] ${className}`}
    >
      {children}
    </a>
  );
}
